const FAST_TRANSFER_MANAGER_CONSTANTS = {
  // Get Fast Transfer Config Actions
  GETTING_FAST_TRANSFER_CONFIG: 'GETTING_FAST_TRANSFER_CONFIG',
  GET_FAST_TRANSFER_CONFIG_SUCCESS: 'GET_FAST_TRANSFER_CONFIG_SUCCESS',
  GET_FAST_TRANSFER_CONFIG_FAILURE: 'GET_FAST_TRANSFER_CONFIG_FAILURE',
  RESET_FAST_TRANSFER_CONFIG_DATA: 'RESET_FAST_TRANSFER_CONFIG_DATA',

  // Update Fast Transfer Config Actions
  UPDATING_FAST_TRANSFER_CONFIG: 'UPDATING_FAST_TRANSFER_CONFIG',
  UPDATE_FAST_TRANSFER_CONFIG_SUCCESS: 'UPDATE_FAST_TRANSFER_CONFIG_SUCCESS',
  UPDATE_FAST_TRANSFER_CONFIG_FAILURE: 'UPDATE_FAST_TRANSFER_CONFIG_FAILURE'
};

export default FAST_TRANSFER_MANAGER_CONSTANTS;
